// removed by extract-text-webpack-plugin
module.exports = {"NewsLetterFooter":"NewsLetterFooter__1OD9q","subscribeText":"subscribeText__8IF5f","flexbox":"flexbox__3I84Y","subscribe":"subscribe__fgG1W","loading":"loading__1wbiu","rotate":"rotate__2lARb","popup":"popup__XidRp","popuptext":"popuptext__2U1Zw","show":"show__uxWwk","fadeIn":"fadeIn__2WPqm","emailBox":"emailBox__FHVj1","newsletterText":"newsletterText__1m4b6"};


//////////////////
// WEBPACK FOOTER
// ./components/NewsLetterFooter/style.scss
// module id = hF6g
// module chunks = 5